import React from 'react';
import { motion } from 'framer-motion';
import { Flame, Tag } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useBlogStore } from '../../store/blogStore';

export const BlogSidebar: React.FC = () => {
  const { posts } = useBlogStore();

  // Derive categories and popular posts from posts array
  const categories = Array.from(new Set(posts.map(post => post.category)));
  const popularPosts = [...posts]
    .sort((a, b) => b.views - a.views)
    .slice(0, 5);

  return (
    <div className="space-y-6">
      {/* Popular Posts */}
      <motion.div 
        className="glass p-6"
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
      >
        <div className="flex items-center space-x-2 mb-4">
          <Flame className="w-5 h-5 text-neon-green" />
          <h3 className="text-lg font-bold">Popular Posts</h3>
        </div>
        <div className="space-y-4">
          {popularPosts.map(post => (
            <Link 
              key={post.id}
              to={`/blog/${post.slug}`}
              className="block group"
            >
              <div className="glass p-3 transition-all duration-200 hover:scale-[1.02]">
                <h4 className="font-medium mb-1 group-hover:text-neon-green transition-colors">
                  {post.title}
                </h4>
                <div className="text-sm text-gray-400">
                  {post.views.toLocaleString()} views
                </div>
              </div>
            </Link>
          ))}
          {popularPosts.length === 0 && (
            <div className="text-gray-400 text-sm">No posts yet</div>
          )}
        </div>
      </motion.div>

      {/* Categories */}
      <motion.div 
        className="glass p-6"
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        <div className="flex items-center space-x-2 mb-4">
          <Tag className="w-5 h-5 text-neon-green" />
          <h3 className="text-lg font-bold">Categories</h3>
        </div>
        <div className="space-y-2">
          {categories.map(category => (
            <Link
              key={category}
              to={`/blog/category/${category.toLowerCase()}`}
              className="block glass p-3 hover:bg-white/5 transition-colors"
            >
              {category}
            </Link>
          ))}
          {categories.length === 0 && (
            <div className="text-gray-400 text-sm">No categories yet</div>
          )}
        </div>
      </motion.div>
    </div>
  );
};